<template>
	<div id="ticket">
		<SubpageHeader
			@on-back="actionBack"
		>
			ビジターチケット
		</SubpageHeader>
		<div class="container-block">
			<div class="container">
				<div class="centerblock">
					<ModalGmo
						v-if="showModalGmo"
						:contents-name="gmoContentsName"
						:contents-money="gmoContentsMoney"
						:val-money="gmoValMoney"
						:enable-point="true"
						@close-modal="closeGmoModal"
						@buy-gmo="doBuyTicket"
						
					></ModalGmo>
					
					<dl class="ticket_status">
						<dt>ビジターチケット利用可能回数</dt>
						<dd>{{ticketStatus.status ? ticketStatus.count : '-'}}回</dd>
					</dl>

					<div v-if="monthlyStatus.status" class="alert alert-success">
						月額会員での利用中のため、利用券、回数券をご購入いただくことはできません。
					</div>

					<div v-else class="ticketbtn">
						<div v-for="info in listTicket" class="one" :key="info.kaisu">
							<button class="btn btn-primary" @click.prevent="clickBuyTicket(info)">{{getContentsName(info).replace('ビジター', '')}}を購入<br />{{getContentsMoney(info)}}</button>
						</div>
						<div class="caution">
							必ず<a href="https://connect.universal-field.com/rule.html" target="_blank">利用規約</a>を確認いただき、ご同意の上、お申込みください									
						</div>
					</div>

					<div class="history">
						<HeaderCaption>利用状況</HeaderCaption>
						<div class="history_loading" v-if="isRunningTicketLog">
							<LoadingMark>
							</LoadingMark>
						</div>
						<div v-if="!isRunningTicketLog" class="history_list">
							<table v-if="existTicketLog" class="history_table">
								<tbody>
									<tr v-for="history, index in listRunningTicketLog" :key="index">
										<td>{{historyDate(history)}}</td>
										<td>{{historyContent(history)}}</td>
									</tr>
								</tbody>
							</table>
							<div v-else class="notrslog">
								利用状況はありません。
							</div>
						</div>
					</div>

				</div>
			</div>
		</div>
	</div>
</template>

<script>
	//import Header from '@/components/Header';
	import ModalGmo from '@/components/ModalGmo';
	import SubpageHeader from '@/components/SubpageHeader';
	import HeaderCaption from '@/components/common/HeaderCaption';
	import LoadingMark from '@/components/LoadingMark';
	import {ymdToText, addFigure} from '@/lib/formatter';

	export default {
		components: {
			SubpageHeader,
			ModalGmo,
			LoadingMark,
			HeaderCaption
			//ApiResponse
		},
		props: {
		},
		data() {
			return {
				// GMO購入
				showModalGmo: false,
				typeModalGmo: 0,
				gmoContentsName: 'a',
				gmoContentsMoney: '100',
				gmoValMoney: 0,
				// 複数回同時購入禁止
				flagClickedBuy: false,
			}
		},
		computed: {
			creditCno() {
				return this.$store.getters['gmoStore/getCreditCno'];
			},
			creditSno() {
				return this.$store.getters['gmoStore/getCreditSno'];
			},
			creditLimitYear() {
				return this.$store.getters['gmoStore/getCreditLimitYear'];
			},
			creditLimitMonth() {
				return this.$store.getters['gmoStore/getCreditLimitMonth'];
			},
			// チケット種類
			listTicket() {
				return this.$store.getters['commonStore/getListTicket'];
			},
			// ランステチケット利用状況取得中
			isRunningTicketLog() {
				return this.$store.getters['commonStore/getRunningTicketLog'];
			},
			// ランステチケット利用状況リスト
			listRunningTicketLog() {
				const runst_list = this.$store.getters['commonStore/getListTicketLog'];
				return runst_list;
			},
			// ランステチケット利用状況が存在するか
			existTicketLog() {
				const runst_list = this.$store.getters['commonStore/getListTicketLog'];
				return runst_list && Array.isArray(runst_list) && runst_list.length;
			},
			// 月額会員状況
			monthlyStatus() {
				return this.$store.getters['commonStore/getMonthlyStatus'];
			},
			ticketStatus() {
				return this.$store.getters['commonStore/getTicketStatus'];
			},
		},
		methods: {
			getContentsName(info) {
				return info.name;
			},
			getContentsMoney(info) {
				return addFigure(info.money)+'円';
			},
			actionBack() {
				this.$router.push('/top');
			},
			closeGmoModal() {
				this.$store.commit('gmoStore/setCreditCno', '');
				this.$store.commit('gmoStore/setCreditSno', '');
				this.$store.commit('gmoStore/setCreditLimitYear', '');
				this.$store.commit('gmoStore/setCreditLimitMonth', '');

				this.showModalGmo = false;
			},
			clickBuyTicket(info) {
				this.showModalGmo = true;
				this.typeModalGmo = info.kaisu;

				this.gmoContentsName = this.getContentsName(info)+'を購入';
				this.gmoContentsMoney = this.getContentsMoney(info);
				this.gmoValMoney = info.money;
			},
			async doBuyTicket(opt) {
				if(this.flagClickedBuy) return;

				this.flagClickedBuy = true;
				const val = this.typeModalGmo;
				const errors = await this.$store.dispatch('gmoStore/validateGmoInput');
				if(errors.length) {
					this.$dialog.alert(errors.join('\n'),{okText: 'OK'});
					this.flagClickedBuy = false;
					return;
				}
				
				let usepoint = opt && opt.usePoint ? opt.usePoint : 0;
				
				const result = await this.$store.dispatch('gmoStore/runBuyTicket', {val, usepoint});
				if(result) {
					if(result.error) {
						this.$dialog.alert(result.error,{okText: 'OK'});
					} else if(result.payload) {
						if(result.payload.ErrCode) {
							const text = result.payload.ErrCode+":"+result.payload.ErrInfo+"\n"+result.payload.ErrMsg;
							this.$dialog.alert(text,{okText: 'OK'});
						} else if(result.payload.OrderID) {
							let text = '決済成功:'+result.payload.OrderID;
							this.$dialog.alert(text,{okText: 'OK'});
							this.closeGmoModal();
							this.$store.dispatch('commonStore/apiTicketLog');
						}
					}
				}
				this.flagClickedBuy = false;
			},
			historyDate(history) {
				return ymdToText(history.ymd);
			},
			historyContent(history) {
				return history.desc;
			},
		},
		mounted() {
			this.$store.dispatch('commonStore/apiTicketLog').then(() => {
			});
		}
	};
</script>

<style lang="scss" scoped>
	#ticket {
		margin: 0 auto;
		padding: 0;
		height: 100vh;
	
		.container-block {	
			padding: 8px;
			.container {
				width: 100%;
				display: flex;
				justify-content: center;
				align-items: center;
				.centerblock {
					.ticket_status {
						display: flex;
						justify-content: center;
						align-items: center;

						border-bottom: solid 1px #333;
						font-size: 16px;
						line-height: 1.4;
						
						dt {
							width: 50%;
							margin: 0;
							text-align: left;
							padding: 0 0 0 1em;
							white-space: nowrap;
						}
						dd {
							width: 50%;
							margin: 0;
							text-align: right;
							padding: 0 1em 0 0;
						}
					}
					.ticketbtn {
						margin-top: 2em;
						display: flex;
						justify-content: center;
						align-items: center;
						flex-wrap: wrap;
						.one {
							width: 50%;
							text-align: center;
							padding: 0 4px 8px;
							button {
								width: 100%;
								max-width: 180px;
								padding: 8px 0;
								white-space: nowrap;
							}
						}
						.empty {
							margin: 0 1em;
						}
						.caution {
							color: #a00;
							padding: 8px 0 16px;
						}

					}
					.history {
						.history_loading {
							width: 32px;
							height: 32px;
							margin: 0 auto;
						}
						.history_list {
							padding: 8px;
						}
						table {
							font-size: 12px;
							width: auto;
							&.history_table {
								td:nth-child(1) {
									text-align: center;
								}
							}
						}
						.notrslog {
							font-size: 14px;
							line-height: 1.7;
						}
					}
				}
			}
		}
	}
</style>
